import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "LionWeb Integration",
description: "How Freon integrates with the LionWeb initiative for model and language interoperability, including JSON interchange, LionWeb repository usage, and converting Freon language definitions to LionWeb format.",
tags: [ "Freon", "LionWeb", "interoperability", "JSON", "repository", "server protocol", "model storage", "serialization", "language definition", "integration", "documentation", "beta"] ,
modifiedTime: "2025-11-07T17:20:18.647Z",
publishedTime: "2025-11-07T17:20:18.647Z"
    }
  };
};